(() => {
  const MQ = window.matchMedia("(max-width: 749px)");

  function initCarousel(groupEl) {
    const track = groupEl.querySelector(".group-block-content");
    if (!track) return;

    const slides = Array.from(track.children).filter((el) => el.nodeType === 1);
    if (slides.length <= 1) return;

    if (track.dataset.evrPillCarouselInit === "1") return;
    track.dataset.evrPillCarouselInit = "1";

    let index = 0;
    let timer = null;
    let pausedUntil = 0;
    let inViewport = false;

    // Only autoplay if the group itself is in viewport (prevents "scroll up" hijacks)
    const viewportIO = new IntersectionObserver(
      (entries) => {
        inViewport = !!entries[0]?.isIntersecting;
      },
      { threshold: 0.25 }
    );
    viewportIO.observe(groupEl);

    // Mark active slide based on what's most visible inside the track
    const io = new IntersectionObserver(
      (entries) => {
        let best = null;
        for (const e of entries) {
          if (!best || e.intersectionRatio > best.intersectionRatio) best = e;
        }
        if (!best) return;

        slides.forEach((s) => s.classList.remove("is-active"));
        best.target.classList.add("is-active");
        index = slides.indexOf(best.target);
      },
      { root: track, threshold: [0.5, 0.6, 0.7, 0.8, 0.9] }
    );
    slides.forEach((s) => io.observe(s));

    function scrollToIndex(i, smooth = true) {
      const el = slides[i];
      if (!el) return;

      // Compute target scrollLeft so the slide is centered in the track
      const elCenter = el.offsetLeft + el.offsetWidth / 2;
      const targetLeft = Math.max(0, elCenter - track.clientWidth / 2);

      track.scrollTo({
        left: targetLeft,
        behavior: smooth ? "smooth" : "auto",
      });
    }

    function startAutoplay() {
      stopAutoplay();
      timer = window.setInterval(() => {
        if (!MQ.matches) return;
        if (!inViewport) return;                 // <— critical
        if (Date.now() < pausedUntil) return;

        index = (index + 1) % slides.length;
        scrollToIndex(index, true);
      }, 2600);
    }

    function stopAutoplay() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    // Pause autoplay on user interaction (track only)
    const pause = () => (pausedUntil = Date.now() + 4000);
    track.addEventListener("scroll", pause, { passive: true });
    track.addEventListener("touchstart", pause, { passive: true });
    track.addEventListener("pointerdown", pause, { passive: true });

    // Initial positioning (no page jump)
    scrollToIndex(0, false);
    startAutoplay();

    track._evrCleanup = () => {
      stopAutoplay();
      io.disconnect();
      viewportIO.disconnect();
      delete track._evrCleanup;
      delete track.dataset.evrPillCarouselInit;
    };
  }

  function boot() {
    document.querySelectorAll(".group-block.evr-pill-carousel").forEach(initCarousel);
  }

  function teardown() {
    document.querySelectorAll(".group-block.evr-pill-carousel .group-block-content").forEach((track) => {
      if (track && track._evrCleanup) track._evrCleanup();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  MQ.addEventListener?.("change", (e) => {
    if (e.matches) boot();
    else teardown();
  });
})();